import {buildCompareActions} from './slices/compare.js';
import {buildFoldersActions} from './slices/folders.js';
import {buildItemTypesActions} from './slices/item-types.js';
import {buildMapActions} from './slices/map.js';
import {buildMosaicsActions} from './slices/mosaics.js';
import {buildResultsActions} from './slices/results.js';
import {buildSearchFilterActions} from './slices/search-filters.js';
import {buildSearchActions} from './slices/search.js';
import {buildTilesActions} from './slices/tiles.js';
import {buildUiActions} from './slices/ui.js';

export const buildActionsFromStoredState = storedState => {
  let actions = [];
  actions = actions.concat(buildUiActions(storedState));
  actions = actions.concat(buildMosaicsActions(storedState));
  actions = actions.concat(buildTilesActions(storedState));
  actions = actions.concat(buildMapActions(storedState));
  actions = actions.concat(buildResultsActions(storedState));
  actions = actions.concat(buildSearchActions(storedState));
  actions = actions.concat(buildSearchFilterActions(storedState));
  actions = actions.concat(buildItemTypesActions(storedState));
  actions = actions.concat(buildFoldersActions(storedState));
  actions = actions.concat(buildCompareActions(storedState));
  return actions;
};
